"use strict";

require("core-js/modules/es.array.iterator");

var go = require("./go.js");

var map = require("./map.js");

var sel = require('./sel.js');

var ifElse = require('./ifElse.js');

var selEq = require("./selEquals.js");

var takeAll = require("./takeAll.js");

var zip = require("./zip.js");

module.exports = unzip;

function unzip(iter) {
  return go(iter, takeAll, ifElse(selEq('length', 1), list => map(Array.of, sel('0', list)), list => zip(...list)));
}

;